import { isPlatformBrowser, NgIf, NgClass, NgFor, TitleCasePipe, CurrencyPipe } from '@angular/common';
import { environment } from './../../environments/environment';
import { Component, HostListener, OnDestroy, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { FormControl, UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';

//* 3rd
import { AnimationOptions, LottieComponent } from 'ngx-lottie';

//* RXJS
import { debounceTime, take, takeUntil } from 'rxjs/operators';
import { SeoService } from '../services/seo.service';
import { Subject, forkJoin } from 'rxjs';
import { AppStateUser } from '../state/user/user.reducer';
import { Store } from '@ngrx/store';

//* Material
import { MatDialog } from '@angular/material/dialog';

//* Components
import { AddProductListsComponent } from '@components/add-product-lists/add-product-lists.component';
import { CartComponent } from '@components/cart/cart.component';
import { SigninComponent } from '@components/signin/signin.component';
import { DeliveryComponent } from '@components/delivery/delivery.component';
import { PdpImagesModalComponent } from '@components/pdp-images-modal/pdp-images-modal.component';

//* Models
import { Item } from '@models/localstorage.model';
import { Item as ICartItem } from '@models/cart.model';
import { TProductTypeQuantity } from '@models/cart.model';
import { IClient } from '@models/client.model';
import { EventCustomData, PixelEvent } from '@models/pixel.model';

//* Services
import { SnackbarService } from '@services/snackbar.service';
import { ListsService } from '@services/lists.service';
import { ProductsService } from '@services/products.service';
import { CartService } from '@services/cart.service';
import { CartObserverService } from '@services/cart-observer.service';
import { AddressObserverService } from '@services/address-observer.service';
import { LocalstorageService } from '@services/localstorage.service';
import { ProductsValidationsService, TProductType } from '@services/products-validations.service';
import { MarketingService } from '@services/marketing.service';

//* Shared
import { DEFAULT_IMAGE_URL } from '@shared/utils';
import { SKELETON_LIST } from '@shared/utils';
import { imageHandling } from '@shared/imageHandling';
import { encryptTextSHA256 } from '@shared/encryptText';
import { v4 as uuidv4 } from 'uuid';
import { ReplaceParentesisPipe } from '../pipes/replace-parentesis.pipe';
import { safeUrlPipe } from '../pipes/safeurl.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { ProductCardComponent } from '../shared/components/product-card/product-card.component';
import { IvyCarouselModule } from 'angular-responsive-carousel2';
import { MatTabsModule } from '@angular/material/tabs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgxMaskDirective } from 'ngx-mask';
import { AsHttpParams } from '@models/AsHttpParams.model';
import { SmartLabelComponent } from '@shared/components/smart-label/smart-label.component';
import { SupermixListsComponent } from '../supermix-lists/supermix-lists.component';
import { AppStateCart } from '../state/cart/cart.reducer';
import { MatTooltipModule } from '@angular/material/tooltip';

declare let gtag: any;
declare let pintrk: Function;
declare let fbq: Function;

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss'],
  standalone: true,
  imports: [NgIf, SmartLabelComponent, MatTooltipModule, LottieComponent, MatFormFieldModule, RouterLink, LazyLoadImageModule, NgClass, MatButtonModule, MatIconModule, FormsModule, MatSelectModule, ReactiveFormsModule, NgFor, MatOptionModule, MatInputModule, MatProgressSpinnerModule, MatTabsModule, IvyCarouselModule, ProductCardComponent, TitleCasePipe, CurrencyPipe, TranslateModule, safeUrlPipe, ReplaceParentesisPipe, NgxMaskDirective]
})
export class ProductComponent implements OnInit, OnDestroy {
  public loading = false;
  public product: any;
  public baseGrams = 0;
  public isMobile: boolean;
  public sliceList: string[] = [];
  public madurityList: string[] = [];
  private subs = new Subject<void>();
  public descriptionActive = 1;
  public loadingProducts = false;
  public productsPromos: any;
  public productQuantityGrams = 50;
  public madurity = new UntypedFormControl();
  public slice = new UntypedFormControl();
  public skeletonList = SKELETON_LIST;
  public carouselProductsHeight = 335;
  public carouselProductsWidth = 200;
  public productsAlsoBought: any;
  public storeId: string;
  public showHeart = false;
  public quantityBaseOnInches: number;
  public applyGranel = false;
  public isBrowser: boolean;
  public showSocial = false;
  public weight: number;
  public linkSelected = 0;
  public showSpinner = false;
  @HostListener('window:resize', ['$event'])
  onResize(): void {
    if (isPlatformBrowser(this.platformId)) this.isMobile = window.innerWidth <= 800;
    this.carouselProductsHeight = this.isMobile ? 270 : 335;
    this.carouselProductsWidth = this.isMobile ? 200 : 200;
  }

  public urlFacebookShare: string;
  public prodLoader = false;
  public options: AnimationOptions = {
    path: '/assets/animations/loader.json',
  };

  public unit: string;

  public productAdded = false;
  public productFromCart: ICartItem | null;
  public productImage: string;
  public cartItems: ICartItem[] = [];
  public favouritesList: any;

  public dontExistProduct = false;
  public defaultImage: string = DEFAULT_IMAGE_URL;
  public recommendedToBuy: any[] = [];

  public productImageCloudFront: string;
  public showStockError = false;

  public quantity: number;
  public productQuantity: number;
  public productType: TProductType;
  public productTypeQuantity: TProductTypeQuantity;
  public client: IClient;

  public noteInput = new FormControl('', [Validators.maxLength(100)]);
  public loadingNote = false;
  public loadingDeleteNote = false;
  public editNote = false;
  private clickSubject = new Subject();

  constructor(
    private dialog: MatDialog,
    private ar: ActivatedRoute,
    private cartService: CartService,
    private productService: ProductsService,
    private cartObserver: CartObserverService,
    private addressObserver: AddressObserverService,
    private listsService: ListsService,
    private snackbarService: SnackbarService,
    @Inject(PLATFORM_ID) private platformId: string,
    private seoService: SeoService,
    private localStorageService: LocalstorageService,
    private productsValidationsService: ProductsValidationsService,
    private marketingService: MarketingService,
    private storeUser: Store<AppStateUser>,
    private storeCart: Store<AppStateCart>
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    if (isPlatformBrowser(this.platformId)) {
      this.storeId = JSON.parse(localStorage.getItem('address') || '{}').store;
    }
  }

  async ngOnInit(): Promise<void> {
    await this.getFavourites(),
      this.getProducts();
    if (isPlatformBrowser(this.platformId)) {
      const withoutSlashArr = window.location.href.split('/');
      const withoutSlash = withoutSlashArr.join('%2F');
      const urlArr = withoutSlash.split(':');
      const url = urlArr.join('%3A');
      this.urlFacebookShare = `https://www.facebook.com/plugins/share_button.php?href=${url}&layout=button&size=large&appId=${environment.facebookKey}&width=103&height=28`;
      this.isMobile = window.innerWidth <= 800;
    }
    this.carouselProductsHeight = this.isMobile ? 270 : 335;
    this.carouselProductsWidth = this.isMobile ? 200 : 200;

    this.ar.paramMap.pipe(takeUntil(this.subs)).subscribe((paramMap: any) => this.resetProductLayout(true, paramMap));

    this.productService.productRefresh$.pipe(takeUntil(this.subs)).subscribe((res: boolean) => {
      if (isPlatformBrowser(this.platformId)) this.storeId = JSON.parse(localStorage.getItem('address') || '{}').store;
      if (res) {
        this.resetProductLayout(false);
      }
    });
    this.getClientData();
    this.setLocalCartListener();
    this.sendQuantityListener();
  }

  ngOnDestroy(): void {
    this.subs.complete();
    this.clickSubject.next('skip');
    this.clickSubject.complete();
  }

  private sendQuantityListener(): void {
    this.clickSubject.pipe(
      debounceTime(600)
    ).subscribe(async (data) => {
      if (data === 'skip') {
        return;
      }
      await this.sendQuantityChange();
    });
  }


  public async sendQuantityChange(): Promise<void> {
    try {
      this.showSpinner = true;
      const { data } = await this.cartService.onHandlingProductQuantity({
        itemId: this.product.item_id ?? this.product.id,
        quantity: Math.round(this.quantity * 1000) / 1000,
        branch_id: this.storeId,
        unit: this.productTypeQuantity,
        variant: this.madurity?.value ? this.madurity?.value : this.slice?.value
      });
      if (data?.message === 'Se ha actualizado la cantidad') {
      } else {
        this.snackbarService.openSnackbar('GENERAL.stockError', 'warn');
      }
      this.showSpinner = false;
      this.onEmitReload();
    } catch (error) {
      this.loading = false;
      this.showSpinner = false;
      this.snackbarService.openSnackbar('GENERAL.stockError', 'warn');
    }
  }


  private async resetProductLayout(route: boolean, paramMap?: any): Promise<void> {
    this.madurity.patchValue(null);
    this.slice.patchValue(null);

    if (!route) {
      const idArr = this.ar.snapshot.params.id.split('-');
      const id = idArr[idArr.length - 1];
      await this.getCart();
      this.getProduct(id);
    } else {
      this.loadingDeleteNote = false;
      this.loadingNote = false;
      this.editNote = false;
      this.productFromCart = null;
      this.noteInput.reset();
      this.productAdded = false;
      const idArr = paramMap.params.id.split('-');
      const id = idArr[idArr.length - 1];
      await this.getCart();
      this.getProduct(id);
    }
  }

  private async setSEOSettings(): Promise<void> {
    this.seoService.updateTitle('Productos | Alsuper');
    this.seoService.updateDescription(this.product.description);
    this.seoService.updateKeyWords('Productos');
    this.seoService.updateOpImage(this.product.image_url);
    if (isPlatformBrowser(this.platformId)) {
      this.seoService.createLinkForCanonicalURL(window.location.href);
      this.seoService.updateUrl(window.location.href);
    }
  }

  private async getCart(): Promise<void> {
    const token = this.localStorageService.getProperty('token');
    if (token?.jwt) {
      try {
        const { data } = await this.cartService.onGettingCartListDirect();
        this.cartItems = data.items;
      } catch (error) { }
    }
  }

  public getClientData(): void {
    this.storeUser.select('user').pipe(takeUntil(this.subs)).subscribe(({ data }) => {
      this.client = data;
    });
  }

  public shareLink(site: string): void {
    if (isPlatformBrowser(this.platformId)) {
      const url = window.location.href;
      switch (site) {
        case 'whatsapp':
          window.open(`${environment.profileWhatsapp}text=${url}`);
          break;
        case 'link':
          this.productService.setCopyLink$.emit(true);
          break;
      }
    }
  }

  public showSocialNetworks(): void {
    this.showSocial = !this.showSocial;
  }

  private async getFavourites(): Promise<void> {
    const token = this.localStorageService.getProperty('token');
    if (token?.jwt) {
      try {
        const res = await this.listsService.getFavouritesLists();
        this.favouritesList = res.data;
        res.data.items.forEach((el: any) => {
          el.items.forEach((item: any) => {
            if (item.sku === this.product.id) {
              this.showHeart = true;
            }
          });
        });
      } catch (error) {
        this.prodLoader = false;
      }
    }
  }

  public addProductToList(): void {
    if (this.localStorageService.getProperty('token')) {
      this.dialog.open(AddProductListsComponent, {
        width: '632px',
        height: 'auto',
        data: { id: this.product.id, quantity: 1, unit: this.productTypeQuantity },
        autoFocus: false
      }).afterClosed().subscribe((res: boolean) => {
        if (res) {
          this.snackbarService.openSnackbar('GENERAL.productAddedToList', 'success');
          this.getFavourites();
        }
      });
    } else {
      this.dialog.open(SigninComponent, {
        autoFocus: false,
      });
    }
  }

  public async addProductToFavouriteList(): Promise<void> {
    if (this.localStorageService.getProperty('token')) {
      this.loading = true;
      try {
        const data = {
          items: [
            {
              sku: this.product.item_id,
              quantity: 1,
              format: this.productTypeQuantity
            }
          ]
        };
        await this.listsService.addProductToFavouritesList(data);
        this.loading = false;
        this.snackbarService.openSnackbar('GENERAL.productAddedToList', 'success');
        this.getFavourites();
      } catch (error) {
        this.loading = false;
        this.snackbarService.openSnackbar('GENERAL.error', 'warn');
      }
    } else {
      this.dialog.open(SigninComponent, { autoFocus: false });
    }
  }

  public async openSureDeleteProductFromList(): Promise<void> {
    try {
      await this.removeProductToList();
    } catch (error) { }
  }

  public async removeProductToList(): Promise<void> {
    try {
      const listArr: any[] = [];
      const res = await this.listsService.getMyLists();
      if (res?.data?.length > 0) {
        res?.data.forEach((el: any) => {
          el?.items?.forEach((element: any) => {
            element?.items.forEach((item: any) => {
              if (item.sku === this.product.id) {
                listArr.push(el.list_id);
              }
            });
          });
        });
      }
      const resp = await this.listsService.getFavouritesLists();
      resp?.data?.items.forEach((el: any) => {
        el?.items?.forEach((item: any) => {
          if (item.sku === this.product.id) {
            listArr.push(resp?.data?.list_id);
          }
        });
      });
      listArr.forEach(async (item: number) => {
        await this.listsService.deleteProductFromList(item, this.product.id);
      });
      this.showHeart = false;
      this.snackbarService.openSnackbar('GENERAL.productRemovedFromList', 'warn');
    } catch (error) {
      this.snackbarService.openSnackbar('GENERAL.error', 'warn');
    }
  }

  public onSeeMoreNavigation(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.scroll(0, 0);
    }
  }

  public goTop(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.scroll(0, 0);
    }
  }

  private async getProduct(id: string): Promise<void> {
    try {
      this.goTop();
      this.showHeart = false;
      this.productAdded = false;
      this.prodLoader = true;
      this.madurityList = [];
      this.sliceList = [];

      const { data } = await this.productService.getProductDirect(id, this.storeId);
      this.product = data;

      this.product.zoomImage = data.image_url;
      const imgHa = imageHandling(this.product.image_url, 'big', '.webp');
      this.productImage = imgHa;

      if (this.product?.long_description !== null && this.product?.long_description !== undefined && this.product?.long_description?.includes('\n')) {
        this.product.long_description = this.product?.long_description?.split('\n');
      } else {
        this.product.long_description = [this.product?.long_description];
        if (this.product?.long_description[0] === undefined) {
          this.product.long_description = undefined;
        }
      }


      if (this.product.department_name) {
        const departmentNameArr = this.product.department_name.split(' ');
        const desc = departmentNameArr.join('-');
        this.product.department_url = `/departamento/${desc.toLowerCase()}-${this.product.department}`;
        const departmentId = `${desc.toLowerCase()}-${this.product.department}`;
        this.product.category_url = {
          departamento_id: departmentId,
          categoria: this.product.category_name,
          categoria_id: this.product.category_id
        };
      }

      if (this.product?.characteristics && this.product?.characteristics !== '()+()+()') {
        this.product.characteristics = this.product?.characteristics?.split('+');
      } else {
        this.product.characteristics = [];
      }

      const format = this.product.format.toUpperCase();
      this.product.format = format === 'KG' ? 'KG' : 'PZ';
      this.product.price = Number.parseFloat(this.product.price);
      this.product.regular_price = Number.parseFloat(this.product.regular_price);
      this.dontExistProduct = false;

      await Promise.all([
        this.setSEOSettings(),
        this.getFavourites(),
      ]);

      this.getRecommendedCarousel(this.product.short_description);

      this.product.unit = this.product?.unit?.trim().toLowerCase();

      this.productType = this.productsValidationsService.productCartTypeValidation(this.product.unit, this.product.weight);

      const lowerVariant = this.product?.variant?.toLowerCase();

      switch (this.productType) {
        case 'grammage':
          this.productTypeQuantity = 'grammage';
          this.productQuantityGrams = this.product?.quantity * 1000;
          this.baseGrams = Number.parseFloat(this.product?.weight) * 1000;
          this.weight = Number.parseFloat(this.product?.weight);
          this.productQuantity = this.baseGrams;
          break;
        case 'pza':
          this.productTypeQuantity = 'pza';
          this.productQuantity = 1;
          break;
        case 'granel':
          this.productTypeQuantity = 'granel';
          this.baseGrams = 50;
          this.weight = 50;
          this.productQuantity = 50;
          this.productQuantityGrams = 50;
          break;
        case 'pza-grammage':
          this.productTypeQuantity = 'pza';
          this.productQuantity = 1;
          this.baseGrams = Number.parseFloat(this.product?.weight) * 1000;
          break;
      }

      if (lowerVariant === 'madurez') {
        this.madurityList = this.product.madurity;
        this.madurity.patchValue('Maduro');
      }
      if (lowerVariant === 'rebanada') {
        this.sliceList = this.product.slice;
        this.slice.patchValue('Rebanada Delgada');
      }
      if (this.cartItems?.length) {
        const product = this.cartItems.find((prod: ICartItem) => prod.item_id === this.product.id);
        if (product) {
          let unit: string;
          this.productFromCart = product;
          this.productAdded = true;

          this.productType = this.productsValidationsService.productCartTypeValidation(this.product.unit, this.product.weight);

          const lowerVariant = this.product?.variant?.toLowerCase();

          switch (this.productType) {
            case 'grammage':
              this.productTypeQuantity = 'grammage';
              this.productQuantityGrams = product?.quantity * 1000;
              this.baseGrams = Number.parseFloat(product?.weight) * 1000;
              this.weight = Number.parseFloat(product?.weight);
              break;
            case 'pza':
              this.productTypeQuantity = 'pza';
              this.productQuantity = product.quantity;
              break;
            case 'granel':
              this.productTypeQuantity = 'granel';
              this.baseGrams = 50;
              this.weight = 50;
              this.productQuantityGrams = product?.quantity * 1000;
              break;
            case 'pza-grammage':
              unit = product.unit.toLowerCase();
              this.baseGrams = Number.parseFloat(product?.weight) * 1000;
              this.weight = Number.parseFloat(product?.weight);

              if (unit === 'grammage') {
                this.productQuantityGrams = product?.quantity * 1000;
                this.productTypeQuantity = 'grammage';
              } else {
                this.productTypeQuantity = 'pza';
                this.productQuantity = product.quantity / Number.parseFloat(product.weight);
                this.productQuantity = Number.parseInt(this.productQuantity.toFixed(2));
              }
              break;
          }

          if (lowerVariant === 'madurez') {
            this.madurityList = this.product.madurity;
            this.madurity.patchValue(product.variant);
          }
          if (lowerVariant === 'rebanada') {
            this.sliceList = this.product.slice;
            this.slice.patchValue(product.variant);
          }

          if (product.comment) {
            this.product.comment = product.comment;
            this.noteInput.setValue(product.comment);
            this.editNote = true;
          }
        } else {
          this.productFromCart = null;
        }
      }
      this.prodLoader = false;
      if (isPlatformBrowser(this.platformId)) {
        window.scroll(0, 0);
        gtag('event', 'view_item', {
          items: [
            {
              id: this.product.id,
              name: this.product.name,
              brand: this.product.name,
              variant: this.product?.price ?? '',
              quantity: 1,
              price: this.product.price
            }
          ]
        });
      }
    } catch (error: any) {
      if (error?.url?.includes('branch') && error?.url?.includes('products')) {
        this.product = null;
        this.prodLoader = false;
        this.dontExistProduct = true;
      }
      if (error?.url?.includes('cart')) {
        this.prodLoader = false;
      }
    }
  }

  private async getRecommendedCarousel(name: string): Promise<void> {
    this.recommendedToBuy = [];
    const nameSplited = name.split(' ');
    const sendKeyWord = nameSplited.slice(0, 2).join(' ');
    let storeId;
    if (isPlatformBrowser(this.platformId)) storeId = JSON.parse(localStorage.getItem('address') || '{}').store;

    const params: AsHttpParams = {
      keyword: sendKeyWord ?? '',
      limit: '30',
      ecommerce: 'true',
      store_id: storeId
    };

    await this.productService.searchProductsDirect(params).pipe(take(1)).subscribe(({
      next: ({ data }) => {
        this.recommendedToBuy = data.data;
        if (this.recommendedToBuy.length) {
          const cartItemsMap = new Map(this.cartItems?.map((item: any) => [item.item_id, item]));
          const favouritesSet = new Set(this.favouritesList?.items?.flatMap((el: any) => el.items.map((item: any) => item.sku)));
          this.recommendedToBuy.forEach((item: any) => {
            if (cartItemsMap.has(item.id)) {
              item.productFromCart = cartItemsMap.get(item.id);
            }
            if (favouritesSet.has(item.sku) || favouritesSet.has(item.id)) {
              item.showHeart = true;
            }
          });
        }
      },
      error: (error) => {
        this.recommendedToBuy = [];
      }
    }));

  }


  private getProducts(): void {
    forkJoin([
      this.productService.getCarouselsById(this.storeId, 'CARRUSEL_EXTRA_2', 1, 15),
      this.productService.getCarouselsById(this.storeId, 'CARRUSEL_EXTRA_3', 1, 15)
    ]).subscribe(([productsAlsoBoughtRes, productsPromosRes]) => {
      this.handleProducts(productsAlsoBoughtRes, 'productsAlsoBought');
      this.handleProducts(productsPromosRes, 'productsPromos');
      this.loadingProducts = true;
    });
  }

  private handleProducts(productsRes: any, property: string): void {
    const productsData = productsRes.data.data;
    if (productsData !== 'emptyArray') {
      const products = productsRes.data;
      const descArr = products?.title.split(' ');
      const desc = descArr.join('-');
      products.product_url = `/carrusel/${desc}`;
      (this as any)[property] = products;
      if (this.cartItems?.length && products.items.length) {
        this.cartItems.forEach((item: any) => {
          products.items.forEach((item2: any) => {
            if (item.item_id === item2.id) {
              item2.productFromCart = item;
            }
          });
        });
      }
      if (this.favouritesList?.items?.length && products.items.length) {
        this.favouritesList?.items?.forEach((el: any) => {
          el.items.forEach((item: any) => {
            products.items.forEach((item2: any) => {
              if (item.sku === item2.sku || item.sku === item2.id) {
                item2.showHeart = true;
              }
            });
          });
        });
      }
    }
  }

  public changeGrams(event: any): void {
    if (event && this.productType !== 'granel') {
      const eventParse = parseInt(event);
      const multiple = (eventParse / this.baseGrams);
      this.productQuantityGrams = Math.round(multiple) * this.baseGrams;
    } else {
      const eventParse = parseInt(event);
      this.productQuantityGrams = eventParse;
    }
    if (this.productAdded) {
      this.changeGramsProductAdded(event);
    }
  }

  public async changeGramsProductAdded(event: any): Promise<void> {
    try {
      if (event) {
        if (this.productType === 'granel') {
          const eventParse = parseInt(event);
          const multiple = eventParse / 1000 / 0.05;
          this.quantity = Math.round(multiple) * 0.05;
        } else {
          const eventParse = parseInt(event);
          const multiple = eventParse / this.productQuantityGrams;
          this.quantity = Math.round(multiple) * this.productQuantityGrams / 1000;
        }

        this.productsValidationsService.editProductInLocalStorage({
          itemId: this.product.item_id ?? this.product.id,
          quantity: Math.round(this.quantity * 1000) / 1000,
          branch_id: this.storeId,
          unit: this.productTypeQuantity,
          variant: this.madurity.value ? this.madurity.value : this.slice.value
        });
      }
      this.onDisplaySuccessPopup();
      this.showStockError = false;
    } catch (error: any) {
      if (error?.status === 404) {
        this.snackbarService.openSnackbar('GENERAL.stockError', 'warn');
        this.showStockError = true;
      }
    }
  }

  public changePieces(event: any): void {
    if (event) {
      this.productQuantity = parseInt(event);
    }

    if (this.productAdded) this.changePiecesProductAdded(event);
  }

  public async changePiecesProductAdded(event: any): Promise<void> {
    try {
      if (event) {
        if (this.productType === 'pza' || this.productType === 'granel') {
          this.quantity = parseInt(event);
        } else {
          const weight = this.productFromCart?.weight ? Number.parseFloat(this.productFromCart.weight) : 0;
          this.quantity = parseInt(event) * weight;
        }

        this.productsValidationsService.editProductInLocalStorage({
          itemId: this.product.item_id ?? this.product.id,
          quantity: Math.round(this.quantity * 1000) / 1000,
          branch_id: this.storeId,
          unit: this.productTypeQuantity,
          variant: this.madurity.value ? this.madurity.value : this.slice.value
        });
      }
      this.onDisplaySuccessPopup();
      this.showStockError = false;
    } catch (error: any) {
      if (error?.status === 404) {
        this.snackbarService.openSnackbar('GENERAL.stockError', 'warn');
        this.showStockError = true;
      }
    }
  }

  public add(): void {
    if (this.productTypeQuantity === 'grammage' || this.productTypeQuantity === 'granel') {
      this.productQuantityGrams += this.baseGrams;
    } else {
      this.productQuantity += 1;
    }
    if (this.productAdded) {
      this.setProductQuantity();

    }
  }

  private setProductQuantity(skipNotify = false): void {
    switch (this.productType) {
      case 'grammage':
      case 'granel':
        this.quantity = this.productQuantityGrams / 1000;
        break;
      case 'pza':
        this.quantity = this.productQuantity;
        break;
      case 'pza-grammage':
        if (this.productTypeQuantity === 'pza') this.quantity = this.productQuantity * Number.parseFloat(this.product.weight);
        if (this.productTypeQuantity === 'grammage') this.quantity = this.productQuantityGrams / 1000;
        break;
    }
    if (!skipNotify) {
      this.clickSubject.next(null);
    }
  }

  public subtract(): void {
    if (this.productTypeQuantity === 'grammage' || this.productTypeQuantity === 'granel') {
      const quantity = this.productQuantityGrams - this.baseGrams;
      if (quantity <= 0) {
        this.onRemoveProduct();
      } else {
        this.productQuantityGrams -= this.baseGrams;
        if (this.productAdded) {
          this.setProductQuantity();
        }
      }
    } else {
      const quantity = this.productQuantity - 1;
      if (quantity <= 0) {
        this.onRemoveProduct();
      } else {
        this.productQuantity -= 1;
        if (this.productAdded) {
          this.setProductQuantity();
        }
      }
    }
  }

  public onChangeActiveButton(active: number): void {
    this.descriptionActive = active;
  }

  public async onAddingToCart(): Promise<void> {
    this.setProductQuantity(true);
    if (this.localStorageService.getProperty('token')) {
      if (this.localStorageService.getProperty('address')) {
        const items = this.localStorageService.getProperty('cartItems');
        const productsAux = items?.map(((product: Item) => product.item_id === this.product.id));
        try {
          if (productsAux?.includes(true)) {
            if (this.product.comment) {
              try {
                await this.cartService.onHandlingProductNote({
                  itemId: this.product.id,
                  comment: this.product?.comment ?? '',
                  branch_id: this.storeId,
                  unit: this.productTypeQuantity,
                  variant: this.madurity.value ? this.madurity.value : this.slice.value
                });
              } catch (error) { }
            }
          } else {
            await this.cartService.onAddingNewProduct({
              items: [{
                itemId: this.product.id,
                quantity: this.quantity,
                branch_id: this.storeId,
                unit: this.productTypeQuantity,
                variant: this.madurity.value ? this.madurity.value : this.slice.value
              }]
            });
            if (this.product.comment) {
              try {
                await this.cartService.onHandlingProductNote({
                  itemId: this.product.id,
                  comment: this.product?.comment ?? '',
                  branch_id: this.storeId,
                  unit: this.productTypeQuantity,
                  variant: this.madurity.value ? this.madurity.value : this.slice.value
                });
              } catch (error) { }
            }
            this.productAdded = true;
            this.onEmitReload();
            this.productAdded = true;
          }
          this.onDisplaySuccessPopup();
          if (isPlatformBrowser(this.platformId)) {
            gtag('event', 'add_to_cart', {
              items: [
                {
                  id: this.product.id.toString(),
                  name: this.product.name,
                  brand: this.product.brand,
                  variant: this.product?.price ?? '',
                  quantity: 1,
                  price: this.product.price.toString()
                }
              ]
            });
            fbq('track', 'AddToCart', {
              content_ids: [this.product.id.toString()],
              price: this.product?.price ?? '',
              currency: 'MXN'
            });
            this.facebookEvent('AddToCart', {
              id: [this.product.id.toString()],
              price: this.product?.price,
              currency: 'MXN'
            });
            //* Pinterest tag
            pintrk('track', 'addtocart', {
              event_id: uuidv4(),
              value: this.product?.price,
              order_quantity: this.product.quantity,
              currency: 'MXN'
            });
          }
          this.showStockError = false;
        } catch (error: any) {
          if (error?.status === 404) {
            this.snackbarService.openSnackbar('GENERAL.stockError', 'warn');
            this.showStockError = true;
          }
        }
      } else {
        this.onSelectingDelivery();
      }
    } else {
      this.dialog.open(SigninComponent, {
        autoFocus: false,
      });
    }
  }

  private facebookEvent(eventName: string, customData: EventCustomData) {
    try {
      const pixelEvent: PixelEvent = {
        data: {
          event_name: eventName,
          event_time: Date.now(),
          action_source: 'website',
          user_data: {
            em: encryptTextSHA256(this.client?.email) ?? '',
            ph: encryptTextSHA256(this.client?.cellphone) ?? '',
            fbp: document.cookie.match('(^|;)\\s*' + '_fbp' + '\\s*=\\s*([^;]+)')?.pop() || '',
            fbc: document.cookie.match('(^|;)\\s*' + '_fbc' + '\\s*=\\s*([^;]+)')?.pop() || '',
            external_id: encryptTextSHA256(this.client?.user_id.toString()) ?? ''
          },
          custom_data: customData,
        }
      };
      this.marketingService.pixelCall(pixelEvent);

    } catch (error) {
    }
  }

  public onDisplaySuccessPopup(): void {
    if (this.productAdded) {
      this.snackbarService.openSnackbar('GENERAL.updateProduct', 'success');
    } else {
      this.snackbarService.openSnackbar('GENERAL.addingProduct', 'success');
    }
  }

  public onDisplayCart(): void {
    this.dialog.open(CartComponent, {
      panelClass: ['as-cart-dialog', 'animate__animated', 'animate__slideInRight'],
      hasBackdrop: true,
      position: { right: 'right' },
      minHeight: '100vh',
      autoFocus: false
    }).afterClosed();
  }

  public onSwitchTypeQuanity(type: TProductTypeQuantity): void {
    if (this.productTypeQuantity === type) return;
    if (type === 'pza') {
      this.productQuantity = this.productQuantityGrams / this.baseGrams;
    } else {
      this.productQuantityGrams = this.baseGrams * this.productQuantity;
    }
    this.productTypeQuantity = type;
    if (this.productAdded) {
      this.onAddingToCart();
    }
  }

  public onSelectingDelivery(): void {
    this.dialog.open(DeliveryComponent, {
      panelClass: 'as-delivery-dialog'
    }).afterClosed().subscribe(response => {
      if (response.status) {
        this.onEmitDisplay(response);
      }
    });
  }

  public goRoute(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.scroll(0, 0);
    }
  }

  public onEmitReload(): void {
    this.cartObserver.cart$.emit(true);
    this.productService.productCardRefresh$.emit(this.product);
  }

  public onEmitDisplay(response: any): void {
    this.addressObserver.address$.emit(response);
  }

  public async onAddingNote(): Promise<void> {
    this.loadingNote = true;
    if (this.noteInput.value) {
      this.product.comment = this.noteInput.value;
      const productComment = {
        itemId: this.product.id,
        comment: this.product?.comment ?? '',
        branch_id: this.storeId,
        unit: this.productTypeQuantity,
        variant: this.madurity.value ? this.madurity.value : this.slice.value
      };
      try {
        await this.cartService.onHandlingProductNote(productComment);
        this.loadingNote = false;
        this.editNote = true;
        this.snackbarService.openSnackbar('GENERAL.noteAdded', 'success');
      } catch (error) {
        this.snackbarService.openSnackbar('GENERAL.noteAddedError', 'warn');
        this.loadingNote = false;
      }
    }
  }

  public async onDeleteNote(): Promise<void> {
    this.loadingDeleteNote = true;
    try {
      await this.cartService.onHandlingDeleteProductNote(this.product.id);
      this.loadingDeleteNote = false;
      this.editNote = false;
      this.noteInput.reset();
      this.snackbarService.openSnackbar('GENERAL.noteAdded', 'success');
    } catch (error) {
      this.snackbarService.openSnackbar('GENERAL.noteAddedError', 'warn');
      this.loadingDeleteNote = false;
    }
  }

  private async onRemoveProduct(): Promise<void> {
    this.clickSubject.next('skip');
    try {
      await this.cartService.onHandlingRemoveProduct(this.product.id);
      this.snackbarService.openSnackbar('GENERAL.deleteProduct', 'success');
      this.onEmitReload();
      this.productAdded = false;
    } catch (error) { }
  }

  public openImagesModal(url: string): void {
    this.dialog.open(PdpImagesModalComponent, {
      width: '100vw',
      height: '100vh',
      maxWidth: '100vw',
      autoFocus: false,
      disableClose: true,
      data: { url }
    });
  }


  public supermixCartSet(): void {
    if (this.cartItems?.length && this.product.super_mix.length) {
      this.cartItems.forEach((item: any) => {
        this.product.super_mix.forEach((supermixItem: any) => {
          if (item.item_id === supermixItem.id) {
            supermixItem.productFromCart = item;
          }
        });
      });
    }
    if (this.favouritesList?.items?.length && this.product.super_mix.length) {
      this.favouritesList?.items?.forEach((el: any) => {
        el.items.forEach((item: any) => {
          this.product.super_mix.forEach((supermixItem: any) => {
            if (item.sku === supermixItem.sku || item.sku === supermixItem.id) {
              supermixItem.showHeart = true;
            }
          });
        });
      });
    }
  }

  public showMore(): void {
    this.supermixCartSet();
    this.dialog.open(SupermixListsComponent, {
      width: this.isMobile ? '100vw' : '730px',
      height: this.isMobile ? '100vh' : 'auto',
      maxWidth: this.isMobile ? '100vw' : '800px',
      data: { product: this.product },
      disableClose: false,
      autoFocus: false
    });
  }

  public setLocalCartListener(): void {
    this.storeCart.select('cart').pipe(takeUntil(this.subs)).subscribe(({ info }) => {
      this.cartItems = info?.items;
      const product = this.cartItems?.find((prod: ICartItem) => prod.item_id === this.product?.id);
      if (product) {
        let unit: string;
        this.productFromCart = product;
        this.productAdded = true;

        this.productType = this.productsValidationsService.productCartTypeValidation(this.product.unit, this.product.weight);

        const lowerVariant = this.product?.variant?.toLowerCase();

        switch (this.productType) {
          case 'grammage':
            this.productTypeQuantity = 'grammage';
            this.productQuantityGrams = product?.quantity * 1000;
            this.baseGrams = Number.parseFloat(product?.weight) * 1000;
            this.weight = Number.parseFloat(product?.weight);
            break;
          case 'pza':
            this.productTypeQuantity = 'pza';
            this.productQuantity = product.quantity;
            break;
          case 'granel':
            this.productTypeQuantity = 'granel';
            this.baseGrams = 50;
            this.weight = 50;
            this.productQuantityGrams = product?.quantity * 1000;
            break;
          case 'pza-grammage':
            unit = product.unit.toLowerCase();
            this.baseGrams = Number.parseFloat(product?.weight) * 1000;
            this.weight = Number.parseFloat(product?.weight);

            if (unit === 'grammage') {
              this.productQuantityGrams = product?.quantity * 1000;
              this.productTypeQuantity = 'grammage';
            } else {
              this.productTypeQuantity = 'pza';
              this.productQuantity = product.quantity / Number.parseFloat(product.weight);
              this.productQuantity = Number.parseInt(this.productQuantity.toFixed(2));
            }
            break;
        }

        if (lowerVariant === 'madurez') {
          this.madurityList = this.product.madurity;
          this.madurity.patchValue(product.variant);
        }
        if (lowerVariant === 'rebanada') {
          this.sliceList = this.product.slice;
          this.slice.patchValue(product.variant);
        }

        if (product.comment) {
          this.product.comment = product.comment;
          this.noteInput.setValue(product.comment);
          this.editNote = true;
        }
      } else {
        this.productFromCart = null;
        this.productAdded = false;
      }
      this.prodLoader = false;
    });
  }
}
